module.exports = __webpack_public_path__ + "static/media/Consent_Icon.44efe7c9.svg";